// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__ih-LM","footer":"Form_footer__1RfMJ"};